// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio_radio__4Zt1K","dot":"Radio_dot__3N7wj","label":"Radio_label__3FSCp","active":"Radio_active__1PCvp"};